import weightedRandom from 'weighted-random'
import experiments from '~/experiments'

class Experiment {
  constructor({ $cookies, $config }) {
    this.$cookies = $cookies
    this.$config = $config

    this.path = '/'

    this.sameSite = ''
    if (this.$config.environment === 'staging') this.sameSite = 'none'
    if (this.$config.environment === 'production') this.sameSite = 'none'

    this.domain = null
    if (this.$config.environment === 'staging')
      this.domain = '.buildstaging.com'
    if (this.$config.environment === 'production') this.domain = '.hotmart.com'

    this.secure = false
    if (this.$config.environment === 'staging') this.secure = true
    if (this.$config.environment === 'production') this.secure = true
  }

  activeExperiments(experiments) {
    experiments = JSON.parse(JSON.stringify(experiments))
    const currentDate = new Date().getTime()
    const result = []

    const filteredExperiments = experiments.filter(
      (experiment) => currentDate <= experiment.expirationDate
    )

    const cookie = this.$cookies.get('exp-jobs') || ''
    const cookieExperiments = []
    if (cookie.length) {
      const cookieValues = cookie.split('!')

      cookieValues.forEach((cookieValue) => {
        const [id, variant] = cookieValue.split('.')

        cookieExperiments.push({ id, variant })
      })
    }

    filteredExperiments.forEach((filteredExperiment) => {
      const findedExperiment = cookieExperiments.find(
        (cookieExperiment) =>
          cookieExperiment.id === filteredExperiment.experimentID
      )
      const hasFindedExperiments = !!findedExperiment

      let randomVariant

      if (!hasFindedExperiments) {
        const weights = filteredExperiment.variants.map(
          (variant) => variant.weight
        )

        randomVariant = weightedRandom(weights)
      } else {
        randomVariant = findedExperiment.variant
      }

      result.push(`${filteredExperiment.experimentID}.${randomVariant}`)
    })

    return result.join('!')
  }

  versionOf(experimentName) {
    const nameFound = experiments.filter(
      (experiment) => experimentName === experiment.name
    )
    const cookieExperiments = []
    let expID = ''
    let activeVariant = ''

    const hasExperimentName = !!nameFound

    if (hasExperimentName) {
      nameFound.forEach((exp) => {
        expID = exp.experimentID
      })
    }

    const cookie = this.$cookies.get('exp-jobs') || ''
    const cookieValues = cookie.split('!')

    cookieValues.forEach((cookieValue) => {
      const [id, variant] = cookieValue.split('.')

      cookieExperiments.push({ id, variant })
    })

    cookieExperiments.filter((item) => {
      if (item.id == expID) {
        activeVariant = item.variant
      }
    })

    return activeVariant
  }

  init() {
    const activeExperiments = this.activeExperiments(experiments)

    this.$cookies.set('exp-jobs', activeExperiments, {
      path: this.path,
      sameSite: this.sameSite,
      domain: this.domain,
      secure: this.secure,
    })
  }
}

export default ({ $cookies, $config }, inject) => {
  inject('experiment', new Experiment({ $cookies, $config }))
}
